var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { height: "100%" } },
    [
      _c(
        "el-table",
        {
          attrs: {
            data: _vm.tableData,
            height: "100%",
            border: true,
            "header-cell-style": { color: "#333333", background: "#EFF6FF" },
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "tdc_name",
              align: "center",
              "min-width": "120",
              label: "城市仓",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "order_no",
              align: "center",
              "min-width": "120",
              label: "订单号",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "supplier_order_no",
              align: "center",
              "min-width": "120",
              label: "供货单编号",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "supplier_name",
              align: "center",
              label: "供应商名称",
            },
          }),
          _c("el-table-column", {
            attrs: { prop: "buyer_name", align: "center", label: "业务名称" },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "sku_code",
              align: "center",
              label: "商品名称（货号）",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [
                      _vm._v(
                        _vm._s(scope.row.title) +
                          "(" +
                          _vm._s(scope.row.sku_code) +
                          ")"
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "supplier_create_time",
              align: "center",
              label: "供货单创建时间",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "order_create_time",
              align: "center",
              label: "订单创建时间",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "product_amt",
              align: "center",
              label: "商品总金额",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "aftersale_amt",
              align: "center",
              label: "售后总金额",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "qc_out_amt",
              align: "center",
              label: "缺货总金额",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "financial_fee",
              align: "center",
              label: "金融手续费(0.4%)",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "service_charges_fee",
              align: "center",
              label: "应收推广奖励",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "service_charges_fee_real",
              align: "center",
              label: "实际推广奖励",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "service_charges_fee_diff",
              align: "center",
              label: "差额",
              "show-overflow-tooltip": "",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "settlement_amt",
              align: "center",
              label: "结算金额",
              "show-overflow-tooltip": "",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }